import axios from 'axios'

// Refresh text only. Keep media, loaded pages, shuffle seeds and selected filters.
export async function refreshPublicText(vm, listKey, username, apply) {
  const language = vm.$i18n.locale
  const { data } = await axios.get(`${process.env.VUE_APP_ROOT_API}/getPublicItems`, { params: { username, text_only: '1' } })
  if (language !== vm.$i18n.locale || vm._isDestroyed) return
  if (!data || !Array.isArray(data.content)) return
  const byId = new Map(data.content.map(row => [Number(row.id), row]))
  const merge = row => {
    const text = byId.get(Number(row.id))
    if (!text) return null
    const {
      original_name, original_alternative_text, translation, name, alternative_text,
    } = text

    return {
      ...row, name, alternative_text, original_name, original_alternative_text, translation,
    }
  }
  vm[listKey] = vm[listKey].map(merge).filter(Boolean)
  if (vm.selectedFile) {
    vm.selectedFile = merge(vm.selectedFile)
    if (!vm.selectedFile) vm.modalOpen = false
  }
  if (apply) vm[apply]()
}
